import React from "react";
import { fmtDate } from "@/lib/constants";
import Avatar from "@/components/Avatar";
import { CheckSquare, Square, UserPlus, X } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function ChecklistItemRow({
  it, canManage, canTick, currentUser, memberMap, members, itemOverdue,
  toggleItem, setItemDue, assignItem, deleteItem,
}) {
  const canToggle = canTick || it.assignee === currentUser.user_id;
  return (
    <div className="flex items-center gap-2 group" data-testid={`checklist-item-${it.item_id}`}>
      <button type="button" disabled={!canToggle} onClick={() => toggleItem(it)}
        data-testid={`checklist-toggle-${it.item_id}`}
        className={`shrink-0 ${canToggle ? "text-zinc-500 hover:text-emerald-600" : "text-zinc-300"}`}>
        {it.done ? <CheckSquare className="h-4 w-4 text-emerald-600" /> : <Square className="h-4 w-4" />}
      </button>
      <span className={`flex-1 text-sm ${it.done ? "line-through text-zinc-400" : "text-zinc-700"}`}>{it.text}</span>
      {canManage ? (
        <input type="date" value={it.due_date || ""} onChange={(e) => setItemDue(it.item_id, e.target.value)}
          data-testid={`checklist-due-${it.item_id}`}
          className={`text-[11px] border rounded-sm px-1 py-0.5 bg-transparent ${itemOverdue(it) ? "border-rose-300 text-rose-600" : "border-zinc-200 text-zinc-500"}`} />
      ) : it.due_date ? (
        <span className={`text-[11px] ${itemOverdue(it) ? "text-rose-600 font-semibold" : "text-zinc-400"}`}>{fmtDate(it.due_date)}</span>
      ) : null}
      {it.done && it.done_by && (
        <span className="text-[10px] text-emerald-600 hidden sm:inline" title={`Ticked by ${memberMap[it.done_by]?.name || "someone"}`}>
          ✓ {memberMap[it.done_by]?.name?.split(" ")[0] || "done"}
        </span>
      )}
      {it.assignee ? (
        <Avatar id={it.assignee} name={memberMap[it.assignee]?.name || "?"} size={20} />
      ) : null}
      {canManage && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="text-zinc-400 hover:text-zinc-900 opacity-0 group-hover:opacity-100 transition-opacity" title="Assign" data-testid={`checklist-assign-${it.item_id}`}>
              <UserPlus className="h-3.5 w-3.5" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="rounded-sm max-h-56 overflow-y-auto">
            {members.map((m) => (
              <DropdownMenuItem key={m.user_id} onClick={() => assignItem(it.item_id, m.user_id)}>
                <Avatar id={m.user_id} name={m.name} size={18} className="mr-2" /> {m.name}
              </DropdownMenuItem>
            ))}
            {it.assignee && <DropdownMenuItem onClick={() => assignItem(it.item_id, null)}>Clear assignee</DropdownMenuItem>}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      {canManage && (
        <button type="button" onClick={() => deleteItem(it.item_id)}
          className="opacity-0 group-hover:opacity-100 text-zinc-400 hover:text-red-600 transition-opacity">
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
